var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD068F20E9B14A6B4Fc50E664C1C4A93Eacf9Cfa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1738 1341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2007_751)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 869,
    cy: 670.5,
    rx: 375,
    ry: 176.5,
    fill: "var(--fill-0, #00B14F)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2007_751",
    x: 0,
    y: 0,
    width: 1738,
    height: 1341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 247,
    result: "effect1_foregroundBlur_2007_751"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD068F20E9B14A6B4Fc50E664C1C4A93Eacf9Cfa2);
export default __webpack_public_path__ + "static/media/d068f20e9b14a6b4fc50e664c1c4a93eacf9cfa2.05b22c0701a40c947e3f8f90dec54f52.svg";
export { ForwardRef as ReactComponent };